var _g, _path, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFileIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 32,
    viewBox: "0 0 28 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_304_838)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28 22.3734C28 23.5357 27.3926 24.6096 26.4067 25.1908L15.5933 31.5642C14.6074 32.1453 13.3926 32.1453 12.4067 31.5642L1.59334 25.1908C0.607375 24.6096 -1.30034e-08 23.5357 0 22.3734L1.42612e-07 9.62661C1.55616e-07 8.46432 0.607376 7.39037 1.59334 6.80923L12.4067 0.435845C13.3926 -0.145282 14.6074 -0.145282 15.5933 0.435845L26.4067 6.80923C27.3926 7.39037 28 8.46432 28 9.62661V22.3734Z",
    fill: "#0066FF"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.99935 9.33301C9.26602 9.33301 8.67268 9.93301 8.67268 10.6663L8.66602 21.333C8.66602 22.0663 9.25935 22.6663 9.99268 22.6663H17.9993C18.7327 22.6663 19.3327 22.0663 19.3327 21.333V13.8863C19.3327 13.533 19.1927 13.193 18.9393 12.9463L15.7193 9.72634C15.4727 9.47301 15.1327 9.33301 14.7793 9.33301H9.99935ZM14.666 13.333V10.333L18.3327 13.9997H15.3327C14.966 13.9997 14.666 13.6997 14.666 13.333Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_304_838"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 32,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/file-icon.7e99c1425fe058c78ca8d8806de3599b.svg";
export { ForwardRef as ReactComponent };